// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__2fBKH","Cardbody":"Card_Cardbody__1SB23","Pricetext":"Card_Pricetext__S1ntv","Image":"Card_Image__dLpSC","Cardcate":"Card_Cardcate__1I19z"};